export default __webpack_public_path__ + "static/media/github-bg.52bf9f55.svg";